import { Height } from '@atlassian/company-hub-common';

import { type CardsDimensions } from './types';

/**
 * Card dimensions for flexible and fixed image height layouts
 *
 * - The max number of cards per row determines the min width of different card sizes
 * - The max width is used in case the first row is not full
 */
export const cardsDimensions: CardsDimensions = {
	[Height.SMALL]: {
		minWidth: 221,
		maxWidth: 380,
		height: 72,
	},
	[Height.MEDIUM]: {
		minWidth: 240,
		maxWidth: 308,
		height: 312,
	},
	[Height.LARGE]: {
		minWidth: 358,
		maxWidth: 640,
		height: 312,
	},
};

/**
 * Dimensions for flexible image height layout cards
 * These have a fixed height value
 */
export const cardsDimensionsFlexible: CardsDimensions = {
	[Height.SMALL]: {
		minWidth: 240,
		maxWidth: 294,
		height: 84,
	},
	[Height.MEDIUM]: {
		minWidth: 240,
		maxWidth: 294,
		height: 320,
	},
	[Height.LARGE]: {
		minWidth: 326,
		maxWidth: 392,
		height: 320,
	},
};

/**
 * Dimensions for fixed image height layout cards
 * These have minHeight/maxHeight for flexible card height
 */
export const cardsDimensionsFixed: CardsDimensions = {
	[Height.SMALL]: {
		...cardsDimensionsFlexible[Height.SMALL],
	},
	[Height.MEDIUM]: {
		minWidth: 240,
		maxWidth: 294,
		minHeight: 52,
		maxHeight: 348,
	},
	[Height.LARGE]: {
		minWidth: 326,
		maxWidth: 392,
		minHeight: 64,
		maxHeight: 424,
	},
};
